<core-helpers-box-list-item
    [close]="remove"
    (onCloseClick)="onRemove.emit(file)"
    [mainText]="mainText"
    (onMainTextClick)="onMainAction($event)"
    [rightText]="getFileExtension(file.name)"
    [actionIcon]="downloadIcon"
    (onIconClick)="downloadAction()"
></core-helpers-box-list-item>
